/**
 * Local SVG asset icons mapping
 * Key: Icon name to use with mat-icon
 * Value: SVG file name in assets folder
 * Make sure to consult with design before adding new icons.
 */
export const LocalAssetIcons = {
  // Navigation & UI
  'arrow-down': 'icon-arrow-down.svg',
  'arrow-left': 'icon-arrow-left.svg',
  'arrow-right': 'icon-arrow-right.svg',
  'arrow-up': 'icon-arrow-up.svg',
  close: 'icon-close.svg',
  'close-x': 'icon-x.svg',
  menu: 'icon-menu.svg',
  search: 'icon-search.svg',
  help: 'icon-help.svg',
  'more-info': 'icon-more-info.svg',
  'more-horizontal': 'more-horizontal.svg',

  // Status & Feedback
  checkmark: 'checkmark.svg',
  'check-mark': 'icon-check-mark.svg',
  cancelled: 'icon-cancelled.svg',
  exclamation: 'icon-exclamation-mark-circle.svg',
  'red-error': 'icon-red-error.svg',
  'alert-red': 'alert_icon_red.svg',
  'info-blue': 'info_icon_blue.svg',

  // Travel & Booking
  plane: 'icon-plane.svg',
  baggage: 'icon-baggage.svg',
  seat: 'icon-seat-small.svg',
  'flight-info': 'flight_info.svg',
  pnr: 'icon-pnr.svg',
  guest: 'icon-guest.svg',
  'lap-infant': 'lap-infant.svg',
  'upgrade-unavailable': 'upgrade-unavailable.svg',
  'ticket-stroke': 'icon-ticket-stroke.svg',

  // Payment
  payment: 'icon-payment-small.svg',
  'cc-visa': 'cc-visa.svg',
  'cc-visa-36x24': 'cc-visa36x24.svg',
  'cc-mastercard': 'cc-mastercard.svg',
  'cc-mastercard-36x24': 'cc-mastercard36x24.svg',
  'cc-amex': 'cc-amex.svg',
  'cc-amex-36x24': 'cc-amex36x24.svg',
  'cc-discover': 'cc-discover.svg',
  'cc-discover-36x24': 'cc-discover36x24.svg',
  'cc-alaska': 'cc-alaska.svg',
  'cc-alaska-36x24': 'cc-alaska36x24.svg',
  'cc-generic': 'cc-generic.svg',
  'cc-generic-36x24': 'cc-generic36x24.svg',

  // Branding
  'alaska-logo': 'alaska-rain-logo-light.svg',
  'rain-logo': 'logo-rain.svg',
  aurora: 'icon-aurora.svg',
  club49: 'icon-elite-club49.svg',

  // Seat map legends
  'seat-map-legend-airport-control': 'seat-map-airport-control.svg',
  'seat-map-legend-blocked': 'seat-map-blocked.svg',
  'seat-map-legend-disabled': 'seat-map-disabled.svg',
  'seat-map-legend-exit-row': 'seat-map-exit-row.svg',
  'seat-map-legend-guest-with-infant-available-to-assign': 'seat-map-guest-with-infant-available-to-assign.svg',
  'seat-map-legend-inoperative': 'seat-map-inoperative.svg',
  'seat-map-legend-junior-jetsetter': 'seat-map-junior-jetsetter.svg',
  'seat-map-legend-main-cabin': 'seat-map-main-cabin.svg',
  'seat-map-legend-main-preferred-tier-fare-blocked': 'seat-map-main-preferred-tier-fare-blocked.svg',
  'seat-map-legend-preferred': 'seat-map-preferred.svg',
  'seat-map-legend-premium-class': 'seat-map-premium-class.svg',
  'seat-map-legend-saver-fare-eligible': 'seat-map-saver-fare-eligible.svg',
  'seat-map-legend-seated': 'seat-map-seated.svg',
  'seat-map-legend-ssr-blocked': 'seat-map-ssr-blocked.svg',
  'seat-map-legend-unassignable': 'seat-map-unassignable.svg',
  'seat-map-legend-undesirable': 'seat-map-undesirable.svg',
  'seat-map-legend-wing-row': 'seat-map-wing-row.svg',

  // Misc
  clock: 'icon-clock.svg',
  calendar: 'icon-date-picker-calendar.svg',
  heart: 'icon-heart.svg',
  cake: 'icon-cake.svg',
  sparkle: 'icon-sparkle-no-fill.svg',
  loading: 'loading.svg',
  refresh: 'icon-refresh.svg',
  'warning-stroke': 'warning-stroke.svg',
  stroke: 'stroke.svg',
} as const;

export type AssetIconName = keyof typeof LocalAssetIcons;
